const Recognize = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='#000'
      fillRule='evenodd'
      d='M9.075 8.117c.41.237.55.76.313 1.17l-1.053 1.826a.571.571 0 1 0 .99.571l4-6.928a.857.857 0 1 1 1.484.857L11.988 10.5a.571.571 0 0 0 .99.571l4-6.928A.857.857 0 0 1 18.462 5l-4 6.928a.571.571 0 1 0 .99.572l2.821-4.887a.857.857 0 0 1 1.485.857l-2.821 4.887a.571.571 0 0 0 .99.571l1.642-2.845a.857.857 0 1 1 1.485.857l-3.357 5.815A6.571 6.571 0 0 1 8.72 20.16l-1.098-.634a5.304 5.304 0 0 1-1.941-7.245l2.223-3.85a.857.857 0 0 1 1.17-.314zm-2.656-.544l-2.223 3.851a6.999 6.999 0 0 0-.636 5.552 5.306 5.306 0 0 1-.849-6.409l2.224-3.85a.857.857 0 0 1 1.484.856zm2.06-1.28l1.876-3.251a.857.857 0 1 1 1.485.857l-.834 1.445-.835 1.445a2.56 2.56 0 0 0-1.693-.496zm5.42-3.675l.11-.19a.857.857 0 0 1 1.564.672 2.56 2.56 0 0 0-1.674-.482z'
    />
  </svg>
);

export default Recognize;
